export type OrderServiceType = 'dine-in' | 'takeaway';

/** Default for POS table/cart orders. */
export const DEFAULT_ORDER_SERVICE_TYPE: OrderServiceType = 'dine-in';

/** Default for online orders missing serviceType (legacy). */
export const ONLINE_ORDER_SERVICE_TYPE: OrderServiceType = 'dine-in';

export const ORDER_SERVICE_TYPE_LABELS: Record<OrderServiceType, string> = {
  'dine-in': 'Dine-in',
  takeaway: 'Takeaway',
};

export function normalizeOrderServiceType(value: unknown): OrderServiceType {
  return value === 'takeaway' ? 'takeaway' : 'dine-in';
}

export function resolveOnlineOrderServiceType(value: unknown): OrderServiceType {
  if (value === 'dine-in' || value === 'takeaway') {
    return value;
  }
  return ONLINE_ORDER_SERVICE_TYPE;
}
